import { render, staticRenderFns } from "./QuestionsList.vue?vue&type=template&id=30e98e40&scoped=true&"
import script from "./QuestionsList.vue?vue&type=script&lang=js&"
export * from "./QuestionsList.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsList.vue?vue&type=style&index=0&id=30e98e40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e98e40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30e98e40')) {
      api.createRecord('30e98e40', component.options)
    } else {
      api.reload('30e98e40', component.options)
    }
    module.hot.accept("./QuestionsList.vue?vue&type=template&id=30e98e40&scoped=true&", function () {
      api.rerender('30e98e40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/QuestionsList.vue"
export default component.exports